
	import { Component, Prop } from 'vue-property-decorator';
	import { BaseView } from '@shared/views/BaseView';
	import { Company, SubjectAggregate } from '@shared/models';
	import { Route } from 'vue-router';
	import CompanyItem from './CompanyItem.vue';
	
	@Component({
		components: {
			CompanyItem,
		},
	})
	export default class ProItemList extends BaseView {

		@Prop({ default: 'Companies' })
		public title: string;

		@Prop({ default: 65 })
		public iconSize: number;

		@Prop({ default: 10 })
		public nameSize: number;

		@Prop()
		public viewRoute: Route;

		@Prop({ default: () => new Array<SubjectAggregate<Company>>() })
		public list: Array<SubjectAggregate<Company>>;

	}

